import { IMetaCodeVariant } from './low-stock-meta';
import { ProductMetaCode } from '@services/MarppleShop/features/ProductMeta';

export class LimitedMeta implements IMetaCodeVariant {
  private readonly is_limited: boolean;

  constructor(is_limited: boolean) {
    this.is_limited = is_limited;
  }

  isLimited(): boolean {
    return this.is_limited;
  }

  getCode(): ProductMetaCode {
    return ProductMetaCode.LIMITED;
  }

  getVariant(): string {
    return 'DEFAULT';
  }
}
